<template>
  <div class="info-box">
    <h2>{{ title }}</h2>
    <div
      ref="content"
      class="table-box"
    >
      <VueScroll
        ref="vs"
        @handle-scroll="handleScroll"
      >
        <table
          cellspacing="0"
          cellpadding="0"
          border="0"
        >
          <slot />
        </table>
      </VueScroll>
    </div>
    <Transition name="slide-fade">
      <a
        v-if="scrollPositon === BOTTOM"
        class="more-end"
      >
        更多 >
      </a>
    </Transition>
  </div>
</template>
<script>

export default {
  props: {
    title: {
      type: String,
      default: '默认',
    },
  },
  data() {
    return {
      // 滚动条相对于父元素框的三种位置状态常量
      TOP: 1,
      MIDDLE: 0,
      BOTTOM: -1,
      // 当前滚动条的状态,初始化的时候为TOP(1代表顶部)
      scrollPositon: 1,
    };
  },
  methods: {
    handleScroll({ scrollTop }, d, event) {
      const height = event.target.scrollHeight;
      // 可使区域大小,也就是下面定义的$content-height
      const contentHeight = 170;
      if (scrollTop === 0) {
        this.scrollPositon = this.TOP;
        return;
      }
      if (scrollTop === height - contentHeight) {
        this.scrollPositon = this.BOTTOM;
        return;
      }
      this.scrollPositon = this.MIDDLE;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";
@import "@/styles/animation/slide.scss";
@import "@/styles/animation/pupup.scss";
$box-width: 520px;
$box-height: 291px;
$content-height: 170px;

.info-box {
  position: relative;
  width: 100%;
  height: $box-height;
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(30, 60, 150, 0.06);
  h2 {
    padding-top: 40px;
    padding-bottom: 20px;
    font-size: 22px;
    line-height: 22px;
    color: $blue;
  }
  .table-box {
    height: $content-height;
    table {
      padding: 0 30px;
      width: 100%;
      table-layout: fixed;
    }
  }
  .more-end {
    display: block;
    margin: auto;
    width: 100px;
    height: 28px;
    line-height: 28px;
    border-radius: 14px;
    border: solid 1px $blue;
    font-size: 14px;
    color: $blue;
  }
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(5px);
}
</style>
